const FALCON_LAZY_VIDEO = 'falcon-lazy-video';

if (!customElements.get(FALCON_LAZY_VIDEO)) {
  class FalconLazyVideo extends HTMLElement {
    #abortController;
    #intersectionObserver;
    #motionPreference;
    #video;
    #visible = false;

    connectedCallback() {
      if (this.#abortController) return;

      this.style.display = 'contents';
      this.#video = this.querySelector('video');
      if (!this.#video) return;

      this.#abortController = new AbortController();
      this.#motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.#video.autoplay = false;
      this.#video.pause();

      document.addEventListener('visibilitychange', this.#syncPlayback, {
        signal: this.#abortController.signal,
      });
      this.#motionPreference.addEventListener('change', this.#syncPlayback);

      if ('IntersectionObserver' in window) {
        this.#intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            this.#visible = entry?.isIntersecting ?? false;
            this.#syncPlayback();
          },
          { threshold: 0.01 }
        );
        this.#intersectionObserver.observe(this.#video);
      } else {
        this.#visible = true;
        this.#syncPlayback();
      }
    }

    disconnectedCallback() {
      this.#intersectionObserver?.disconnect();
      this.#motionPreference?.removeEventListener('change', this.#syncPlayback);
      this.#abortController?.abort();
      this.#video?.pause();

      this.#intersectionObserver = undefined;
      this.#motionPreference = undefined;
      this.#abortController = undefined;
      this.#video = undefined;
      this.#visible = false;
    }

    #syncPlayback = () => {
      if (!this.#video) return;

      const shouldPlay =
        this.hasAttribute('data-autoplay') &&
        this.#visible &&
        !document.hidden &&
        !this.#motionPreference?.matches;

      if (shouldPlay) {
        this.#video.preload = 'metadata';
        this.#video.play().catch(() => {});
      } else {
        this.#video.pause();
      }
    };
  }

  customElements.define('falcon-lazy-video', FalconLazyVideo);
}
